export default "__VITE_ASSET__cwPTUyo5__"